import { Link, Text } from 'platform-components';
import React from 'react';

// @ts-ignore
import { IconPlus } from 'common.components/icon2';

import './assignment__add-students-control.scss';

interface Props {
    canEditTeam: boolean;
    onAddStudentsClick: () => void;
}

export const AssignmentAddStudentsControl = React.memo((props: Props) => {
    const { canEditTeam, onAddStudentsClick } = props;

    if (!canEditTeam) {
        return null;
    }

    return (
        <Link mix="assignment__add-students-link" onClick={onAddStudentsClick} pseudo theme={Link.THEME.PRIMARY}>
            <IconPlus />
            <Text id="assignLessonModal.addStudents" weight={Text.WEIGHT.M} />
        </Link>
    );
});
